/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ending_Event_IdInputs */

const en_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ending Event Id`)
};

const fr_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d’événement de fin`)
};

const de_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereignis-ID`)
};

const it_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID evento finale`)
};

const ru_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор завершающего события`)
};

const es_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id. del evento final`)
};

const zh_cn2_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束事件 ID`)
};

const ja_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了イベントID`)
};

const hi_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति घटना आईडी`)
};

const pt_pt2_ending_event_id = /** @type {(inputs: Ending_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do evento de término`)
};

/**
* | output |
* | --- |
* | "Ending Event Id" |
*
* @param {Ending_Event_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ending_event_id = /** @type {((inputs?: Ending_Event_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ending_Event_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ending_event_id(inputs)
	if (locale === "de") return de_ending_event_id(inputs)
	if (locale === "it") return it_ending_event_id(inputs)
	if (locale === "ru") return ru_ending_event_id(inputs)
	if (locale === "es") return es_ending_event_id(inputs)
	if (locale === "zh-CN") return zh_cn2_ending_event_id(inputs)
	if (locale === "ja") return ja_ending_event_id(inputs)
	if (locale === "hi") return hi_ending_event_id(inputs)
	if (locale === "pt-PT") return pt_pt2_ending_event_id(inputs)
	return en_ending_event_id(inputs)
});